import {BaseModel} from "../base-model";

export class BaseLinkModelSettings extends BaseModel {
  fullRefresh: Boolean;
  resetState: Boolean;
  forceScrollToTop: Boolean;
  forcePush: Boolean;
  disabled: Boolean;
  shouldOpenNewTab: Boolean;
  updateTime: Number;

  constructor(
    refresh: Boolean,
    resetState: Boolean,
    forceScrollToTop: Boolean,
    forcePush: Boolean,
    disabled: Boolean,
    shouldOpenNewTab: Boolean,
  ) {
    super();

    this.fullRefresh = refresh;
    this.resetState = resetState;
    this.forceScrollToTop = forceScrollToTop;
    this.forcePush = forcePush;
    this.disabled = disabled;
    this.shouldOpenNewTab = shouldOpenNewTab;
    this.updateTime = Date.now();
  }

  equals(model: BaseLinkModelSettings): * {
    let equals = super.equals(model);

    equals &= this.fullRefresh === model.fullRefresh;
    equals &= this.resetState === model.resetState;
    equals &= this.forceScrollToTop === model.forceScrollToTop;
    equals &= this.forcePush === model.forcePush;
    equals &= this.updateTime === model.updateTime;
    equals &= this.shouldOpenNewTab === model.shouldOpenNewTab;

    return equals;
  }
}
